<template>
  <div
    class="artwork"
    @touchstart="touchstart"
    @touchmove="touchmove"
    :artworkvisible="this.$parent.$parent.artworkVisible"
  >
    <div class="img-container">
      <div>
        <img v-if="url" :src="url.replace('p-s256', isMobile ? 'h256' : 'h512')" class="br2" />
      </div>
    </div>
    <div class="desc w-100 mb3">
      <h4 class="title tc w-100 f5">{{ description }}</h4>
      <p class="author tc w-100 f6">
        {{ author }}
        <span v-if="date" class="date f6">({{ date }})</span>
      </p>
      <p class="collection tc w-100 f6">{{ collection }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      isMobile: true
    };
  },
  props: {
    id: String,
    height: Number,
    author: String,
    date: String,
    description: String,
    disabled: Boolean,
    pageUrl: String,
    url: String,
    thumbUrl: String,
    collection: String
  },
  methods: {
    touchstart(e) {
      this.startX = e.touches[0].clientX;
    },
    touchmove(e) {
      if ((e.touches[0].clientX, this.startX) > 100) {
        this.close();
      }
    },

    close() {
      console.log("close");
      this.$root.$emit("image:hide");
    }
  }
};
</script>

<style scoped>
.artwork {
  display: flex;
  flex-direction: column;
  z-index: 2;
  opacity: 1;
  margin: 3rem;
  overflow: scroll;
  background: white;
  border: none;
  position: absolute;
  width: 100vw;
  will-change: opacity;
  transition: 0.4s opacity;
  max-height: stretch;
  opacity: 0;
  height: 100%;
  background: white;
  padding-top: 36px;
}

.artwork img {
  width: auto;
  height: auto;
}

.img-container {
  /* flex: 1; */
  display: flex;
  align-items: center;
  justify-content: center;
  align-items: stretch;
  max-height: 80%;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.img-container > div {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

img {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  border-radius: 5px;
  object-fit: contain;
}

.desc {
  padding: 0 1rem;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  width: 100%;
  max-width: 350px;
  padding: 1rem;
  margin: 0 auto;
}

.desc > div:first-child {
  flex: 1;
}

.title,
.author,
.collection {
  margin: 0;
  font-weight: 300 !important;
}

.title {
  margin-bottom: 0.5rem;
}

.date {
  opacity: 0.5;
}

.author,
.collection {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  /* color: #3c4043; */
  margin-top: 0;
}

.more-details {
  font-weight: 500;
  color: white;
  margin-top: 0;
  background: #1e8e3e;
  text-decoration: none;
  padding: 0.2rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  border-radius: 5px;
}

.buttons {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  border-radius: 5px;
  display: none;
}

.back-button {
  display: none;
}

.artworkVisible .artwork {
  opacity: 1;
  z-index: 10;
}

.inactive {
  pointer-events: none;
}

@media screen and (max-width: 1000px) {
  .draggable {
    pointer-events: none;
  }

  .back-button {
    display: block;
    position: absolute;
    background: #1e8e3e;
    height: 48px;
    width: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    top: 160px;
    z-index: 5;
    left: 10px;
  }

  .back-button svg {
    position: relative;
    left: 5px;
  }

  .buttons {
    display: none;
  }
}

@media (orientation: landscape) and (hover: none) and (pointer: coarse) {
  .artwork {
    padding: 32px 0px;
    flex-direction: row;
  }
  .desc {
    width: 50%;
    margin-left: 24px;
    padding: 0;
    margin-right: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
  }
  .title,
  .author,
  .collection {
    text-align: left;
    margin-left: 0px;
    padding-left: 0px;
  }
  .img-container {
    width: 50%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    -webkit-box-align: center;
    margin-left: 24px;
    margin-right: 0;
    align-items: stretch;
  }
}
</style>
